import { VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { ShadowIdBadge } from "../../-components/ShadowIdBadge";

type Props = {
	loginId: string | undefined | null;
	isShadowId: boolean;
};

/**
 * ログインに使用されたIDを表示するセルコンポーネント
 * Shadow IDの場合はバッジを表示する
 */
export function LoginIdCell({ loginId, isShadowId }: Props) {
	if (!loginId) {
		return (
			<Text variant="labelSmall" className="text-neutral-muted-on-fill">
				-
			</Text>
		);
	}

	return (
		<VStack className="gap-1">
			<Text variant="label">{loginId}</Text>
			{isShadowId && <ShadowIdBadge />}
		</VStack>
	);
}
